import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    '& > td': {
      [theme.breakpoints.down('md')]: {
        '&:not(:first-of-type):not(:last-of-type):not(:nth-last-of-type(2))': {
          borderBottom: `2px solid ${alpha(theme.palette.text.primary, 0.05)}`,
          paddingBottom: theme.spacing(2),
        },
      },
    },
  },

  tokensCell: {
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(5),
    },
  },

  infoIcon: {
    [theme.breakpoints.down('md')]: {
      width: 16,
      height: 16,
      minWidth: 16,
      alignSelf: 'flex-start',
      marginTop: theme.spacing(0.5),
    },
  },

  button: {
    minWidth: 136,

    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginTop: theme.spacing(4),
    },
  },
}));
